import React from "react";

export const DatabaseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16.005"
      height="20"
      viewBox="0 0 16.005 20"
    >
      <g id="database" transform="translate(-2.922)">
        <path
          id="Path_225540"
          data-name="Path 225540"
          d="M10.923,14.755c-3.755,0-6.9-1.1-7.761-2.591a1.627,1.627,0,0,0-.239.816v2.434c0,1.88,3.583,3.406,8,3.406s8-1.526,8-3.406V12.98a1.617,1.617,0,0,0-.242-.816C17.826,13.651,14.682,14.755,10.923,14.755Z"
          transform="translate(0 -3.85)"
          fill="#ce768b"
        />
        <path
          id="Path_225541"
          data-name="Path 225541"
          d="M10.923,22.111c-3.755,0-6.9-1.1-7.761-2.589a1.618,1.618,0,0,0-.239.814v2.436c0,1.881,3.583,3.406,8,3.406s8-1.524,8-3.406V20.336a1.6,1.6,0,0,0-.242-.813C17.826,21.007,14.682,22.111,10.923,22.111Z"
          transform="translate(0 -6.178)"
          fill="#ce768b"
        />
        <path
          id="Path_225542"
          data-name="Path 225542"
          d="M18.709,5.042c-.157,1.378-3.576,2.48-7.786,2.48S3.3,6.42,3.139,5.043a1.617,1.617,0,0,0-.217.78V8.257c0,1.881,3.583,3.406,8,3.406s8-1.524,8-3.406V5.823A1.623,1.623,0,0,0,18.709,5.042Z"
          transform="translate(0 -1.596)"
          fill="#ce768b"
        />
        <path
          id="Path_225543"
          data-name="Path 225543"
          d="M11.017,5.154c4.308,0,7.8-1.153,7.8-2.578S15.325,0,11.017,0s-7.8,1.154-7.8,2.578S6.711,5.154,11.017,5.154Z"
          transform="translate(-0.094)"
          fill="#ce768b"
        />
      </g>
    </svg>
  );
};
